import { render, staticRenderFns } from "./LearnerPrivateReviewPage.vue?vue&type=template&id=1342622a&scoped=true"
import script from "./LearnerPrivateReviewPage.vue?vue&type=script&lang=js"
export * from "./LearnerPrivateReviewPage.vue?vue&type=script&lang=js"
import style0 from "./LearnerPrivateReviewPage.vue?vue&type=style&index=0&id=1342622a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1342622a",
  null
  
)

export default component.exports